module.exports = __webpack_public_path__ + "static/media/virus (8).d408cb4d.png";